import { Record } from 'immutable';
import Hydrator from 'utils/Hydrator';

const LenderRecord = Record({
  id: 0,
  name: '',
  entityId: 0,
  companyNumber: '',
  companyName: '',
  entityType: 0,
  introducerType: 0,
  companyType: 0,
  contactName: '',
  contactEmail: '',
  logo: '',
  logoUrl: '',
  lenderType: 0,
  description: '',
  hasInstantOffer: false,
  hasInstantApplication: false,
  createdAt: new Date(0),
  updatedAt: new Date(0),
});

export default class Lender extends LenderRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      createdAt: Hydrator.timestamp2Date,
      updatedAt: Hydrator.timestamp2Date,
    };

    const keyTransformer = {
      logo: 'logoUrl',
    };

    const hydrated = Object.keys(jsonObject).reduce(
      Hydrator.assign(jsonObject, mapProperties, keyTransformer),
      {},
    );

    return new Lender(hydrated);
  }
}
